import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { MKT_ADS_DESIGN as d } from '../MktAds.design';

// Estado inicial da tela de Anúncios: sem conta de anúncios utilizável não há
// número nenhum para mostrar, e o alerta discreto do topo não dizia ONDE
// conectar — o cliente ficava rodando entre Anúncios e Contas Sociais.
//
// Dois casos, mesma ação (o OAuth mora em Contas Sociais, que precisa do
// grupo de escopos e da seleção de conta depois do redirect):
// - nenhuma conta de anúncios: é a primeira conexão;
// - conta conectada mas sem escopo de anúncios: falta refazer o login
//   aceitando a etapa de anúncios.
export default function AdsConnectHero({ capabilities, onConnect }) {
    const { t } = useTranslation('marketing');

    // capabilities.accounts lista as contas meta_ads; nenhuma delas = primeira
    // conexão. Com contas presentes, o que falta é permissão.
    const semConta = !(capabilities?.accounts || []).length;
    const variante = semConta ? 'noAccount' : 'noScope';

    return (
        <div className={d.connectHero.card}>
            <div className={d.connectHero.iconBox}>
                <Iconify icon="logos:facebook" width={30} />
            </div>

            <h2 className={d.connectHero.title}>{t(`ads.connect.${variante}Title`)}</h2>
            <p className={d.connectHero.subtitle}>{t(`ads.connect.${variante}Subtitle`)}</p>

            <button type="button" className={d.connectHero.cta} onClick={onConnect}>
                <Iconify icon="eva:link-2-outline" width={16} />
                {t(`ads.connect.${variante}Cta`)}
            </button>

            <div className={d.connectHero.steps}>
                {['step1', 'step2', 'step3'].map((passo, i) => (
                    <div key={passo} className={d.connectHero.step}>
                        <span className={d.connectHero.stepNumber}>{i + 1}</span>
                        <p className={d.connectHero.stepText}>{t(`ads.connect.${passo}`)}</p>
                    </div>
                ))}
            </div>

            <p className={d.connectHero.footnote}>
                <Iconify icon="eva:info-outline" width={14} />
                {t('ads.connect.footnote')}
            </p>
        </div>
    );
}
